import * as z from "zod/v4";

export const recreateDiscounts = {
  name: "recreateDiscounts" as const,
  input: z.object({ discountCodes: z.array(z.string()) }),
  output: z.object({ success: z.boolean() }),
};
